import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "../icons";
import PlayStore from "../../assets/images/google-play-badge.png";
import AppStore from "../../assets/images/app-store-badge.png";
import { ContainerFrame } from ".";
import { useState, useEffect } from "react";
import { BannerAPI } from "@api";

const Button = styled.button`
  border-radius: 50%;
  border: #ffb81c thin solid;
  background: transparent;
  display: grid;
  width: 1.5em;
  height: 1.5em;
  margin: 0.25em;

  & svg {
    fill: #ffb81c;
    height: 100%;
    width: 100%;
  }

  &:hover {
    background: #ffb81c;
  }

  &:hover svg {
    fill: #000;
  }
`;

const Header = styled.div`
  font-size: 0.9em;
  padding-bottom: 1em;
`;

const Title = styled.div`
  font-size: 2em;
  font-weight: 600;
`;

const Footer = styled.div`
  display: flex;
  margin: 1.5em 0;
`;

const Badge = styled.img`
  height: 3em;
  padding-right: 0.5em;
`;

const ImageContainer = styled.img`
  width: 100%;
`;

const AppSection = () => {
  const [banner, setBanner] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    async function loadData() {
      if (!banner) {
        const bannerData = (await BannerAPI({ loc: "home_product_digital" }))
          .data.data[0];
        setBanner(bannerData);
      }
    }

    loadData();
  }, [banner]);

  return (
    <div>
      <ContainerFrame>
        <Row className="text-start align-items-center">
          <Col className="pb-2">
            <ImageContainer src={banner !== null ? banner.image : ""} />
          </Col>
          <Col>
            <Header className="row">
              <div className="col-8 d-flex justify-content-start align-items-center">
                <div className="color-brown">{t("our_digital_product")}</div>
              </div>
              <div className="col d-flex justify-content-end">
                <Button>
                  <ChevronLeft />
                </Button>
                <Button>
                  <ChevronRight />
                </Button>
              </div>
              <Title className="col-12">
                {banner !== null ? banner.title : ""}
              </Title>
              <small>{banner !== null ? banner.description : ""}</small>
              <Footer>
                <Badge src={PlayStore} />
                <Badge src={AppStore} />
              </Footer>
            </Header>
          </Col>
        </Row>
      </ContainerFrame>
    </div>
  );
};

export default AppSection;
